import { isBefore, startOfToday } from "date-fns";

import { AppointmentSlotsByDate, Provider } from "~/services";
import { CalendarDay } from "~/shared.types";
import { formatDateKey } from "./format-date-key";

type GetFirstDayWithSlotsParams = {
  days: CalendarDay[];
  appointmentSlotsByProvider?: Provider[];
  appointmentSlotsByFirstAvailable?: AppointmentSlotsByDate;
  isProviderView?: boolean;
};

export const getFirstDayWithSlots = ({
  days,
  appointmentSlotsByProvider,
  appointmentSlotsByFirstAvailable,
  isProviderView = true,
}: GetFirstDayWithSlotsParams): CalendarDay | null => {
  const today = startOfToday();
  const minDate = today;

  for (const day of days) {
    if (isBefore(day.date, minDate)) {
      continue;
    }

    const dateString = formatDateKey(day.date);

    let hasSlots = false;

    if (isProviderView) {
      hasSlots =
        appointmentSlotsByProvider?.some(
          (provider) => provider.slots[dateString]?.length > 0,
        ) ?? false;
    } else {
      hasSlots =
        (appointmentSlotsByFirstAvailable?.[dateString]?.length ?? 0) > 0;
    }

    if (hasSlots) {
      return day;
    }
  }

  return null;
};
